( function ( ) {
	'use strict';
	/* eslint no-use-before-define:0 */

	/* @ngInject */
	function evidenceView ( EVDICONS ) {
		function link ( scope ) {
			scope.icons = EVDICONS;

			scope.viewDetailMode = false;

			scope.$on( 'closeAllDetails', function () {
				scope.viewDetailMode = false;
			} );

			function viewDetails () {
				if ( !scope.viewDetailMode ) {
					scope.$root.$broadcast( 'closeAllDetails' );
				}

				scope.viewDetailMode = !scope.viewDetailMode;
			}

			scope.viewDetails = viewDetails;
		}

		var directive = {
			'link'         : link,
			'restrict'     : 'E',
			'templateUrl'  : '/templates/components/evidences/pool/evidence-view.html',
			'controller'   : 'EvidenceViewModalCtrl',
			'controllerAs' : 'vm',
			'scope'        : {
				'evidence'        : '=',
				'pool'            : '=',
				'clone'           : '=',
				'identifier'      : '@',
				'hasAllEvidences' : '=',
				'observation'     : '='
			}
		};

		return directive;
	}

	angular
		.module( 'app.components' )
		.directive( 'evidenceView', evidenceView );

	evidenceView.$inject = [ 'EVDICONS' ];
} )( );
